import httpHelper from "./httpHelper.js";

// Shared builder for the `csv-inside` report endpoint, used by both the single
// report view (Report.vue) and the two-report diff view (Diff.vue).
export function csvInsideUrl(taskId) {
  const backendUrl = process.env.VUE_APP_VISUALIZER_BACKEND_URL;
  const backendToken = process.env.VUE_APP_BACKEND_TOKEN;
  return `${backendUrl}/csv-inside/${taskId}/?token=${backendToken}`;
}

export async function fetchCsvInside(taskId) {
  const response = await fetch(csvInsideUrl(taskId));
  const data = await httpHelper.safeJson(response);
  return { response, data };
}

export default { csvInsideUrl, fetchCsvInside };
